import TinyButton from '@kaidam/fc-shared/src/frontend/components/widgets/TinyButton'
export default TinyButton